export default function Project({data}) {
    return (
        <div className="project">
            <div className="project-info">
                <h3>{data.name}</h3>
            </div>
            <div className="project-content">
                <span>{data.desc}</span>
            </div>
            {Object.entries(data.url).map(([linkName, linkUrl]) => (
                <a href={linkUrl}>
                    {linkName}
                </a>
            ))}
        </div>
    )
}